import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Pricelist } from 'src/app/model/pricelist';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-pricelist-gear',
  templateUrl: './pricelist-gear.component.html',
  styleUrls: ['./pricelist-gear.component.css']
})
export class PricelistGearComponent implements OnInit {
  public dataSourceGearChildren = new MatTableDataSource<Pricelist>();
  displayedColumnsGearChildren = ['numberOfDays','priceSet','priceSki', 'priceShoes'];
  public dataSourceGearAdults = new MatTableDataSource<Pricelist>();
  displayedColumnsGearAdults = ['numberOfDays','priceSet','priceSki', 'priceShoes'];
  public dataSourceGearVIP = new MatTableDataSource<Pricelist>();
  displayedColumnsGearVIP = ['numberOfDays','priceSet','priceSki', 'priceShoes'];
  public dataSourceGearOther = new MatTableDataSource<Pricelist>();
  displayedColumnsGearOther = ['numberOfDays','priceSet','priceBoard', 'priceShoes'];
  constructor( private dataService: DataService) { 
   
  }
  ngOnInit() {
    this.dataService.getPriceListGearByGroupType(1).subscribe(data => (this.dataSourceGearChildren.data = data as Pricelist[]));
    this.dataService.getPriceListGearByGroupType(2).subscribe(data => (this.dataSourceGearAdults.data = data as Pricelist[]));
    this.dataService.getPriceListGearByGroupType(3).subscribe(data => (this.dataSourceGearVIP.data = data as Pricelist[]));
    this.dataService.getPriceListGearByGroupType(4).subscribe(data => (this.dataSourceGearOther.data = data as Pricelist[]));
  }

}
